import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SampleRequestUpdateService {
  private productDeletedSubject = new BehaviorSubject<any>(null);
  private sampleOrderUpdatedSubject = new BehaviorSubject<any>(null);

  constructor() { }

  /**
   * Emit when a product is deleted from the sample request
   */
  emitProductDeleted(deletedProductId: number): void {
    this.productDeletedSubject.next({ productId: deletedProductId, timestamp: Date.now() });
  }

  /**
   * Observable for product deletion events
   */
  getProductDeletedObservable(): Observable<any> {
    return this.productDeletedSubject.asObservable();
  }

  /**
   * Emit when the sample order is updated (after deletion or other changes)
   */
  emitSampleOrderUpdated(updatedOrder: any): void {
    this.sampleOrderUpdatedSubject.next(updatedOrder);
  }

  /**
   * Observable for sample order updates
   */
  getSampleOrderUpdatedObservable(): Observable<any> {
    return this.sampleOrderUpdatedSubject.asObservable();
  }
}
